import axios from 'axios'
import { ContentType } from '@insided/shared/utils/contentType'
import { publish } from '@insided/deprecated-utils/globals'

export async function getSpamContentCount() {
  return await axios.get('/community/api/spamContent/count')
}

export async function markPostsAsSpam(posts: Object[]) {
  await axios.post('/community/api/bulk/process', {
    action: 'markAsSpam',
    topics: posts
  })

  await axios.post('/community/api/invalidateCache?apiPath=spamContent/count')
  publish('posts_marked_as_spam', {})
}

export async function markPostsAsNotSpam(posts: Object[]) {
  await axios.post('/community/api/bulk/process', {
    action: 'markAsNotSpam',
    topics: posts
  })

  await axios.post('/community/api/invalidateCache?apiPath=spamContent/count')
  publish('posts_marked_as_not_spam', {})
}

export async function isSpam(id: number, contentType: ContentType, isReply: boolean) {
  return await axios.post('/community/api/spamContent/isSpam', {
    id,
    contentType,
    isReply
  })
}
